import { Card, Flex, Group, Image, Stack, Text, Title } from '@mantine/core'
import { TwContainer } from '@/lib/components/TwContainer'

export const HivSectionTwo = () => {
	return (
		<section>
			<TwContainer className={'justify-center py-16 pt-32 gap-12'} column>
				<Title ta={'center'} variant={'cyan'} fz={18}>
					Services
				</Title>
				<Title variant={'title'}>What To Expect</Title>
				<Group gap={0} justify={'space-around'}>
					<Stack className={'max-w-lg p-8'} gap={'xs'}>
						<Title variant={'title2'}>HIV Testing</Title>
						<Text variant={'gray'} ta={'left'}>
							When it comes to Human Immunodeficiency Virus (HIV), the first step to treatment and prevention is knowing through our high-accuracy
							rapid tests.
						</Text>
					</Stack>
					<Image
						loading={'lazy'}
						className={'md:max-w-sm max-w-xs rounded-[32px]'}
						src={'/images/img_21.webp'}
						w={380}
						h={380}
						alt={'Sexually transmitted infections (STIs)'}
					/>
				</Group>
				<Group gap={0} justify={'space-around'}>
					<Image
						loading={'lazy'}
						className={'order-last md:order-first md:max-w-sm max-w-xs rounded-[32px]'}
						src={'/images/img_22.webp'}
						w={380}
						h={380}
						alt={'Human Immuno deficiency Virus (HIV)'}
					/>
					<Stack className={'max-w-lg p-8'} gap={'xs'}>
						<Title variant={'title2'}>HIV Prevention</Title>
						<Text variant={'gray'} ta={'left'}>
							With streamlined access to PrEP to prevent HIV for high-risk individuals and PEP to prevent infections for individuals exposed within 72
							hours, we prioritize prevention.
						</Text>
					</Stack>
				</Group>
				<Group gap={0} justify={'space-around'}>
					<Stack className={'max-w-lg p-8'} gap={'xs'}>
						<Title variant={'title2'}>HIV Treatments</Title>
						<Text variant={'gray'} ta={'left'}>
							For HIV-positive individuals, our preferred treatment method is BIKTARVY®, a daily prescription taken as a small pill that aligns
							seamlessly with your daily routine.
						</Text>
					</Stack>
					<Image
						loading={'lazy'}
						className={'md:max-w-sm max-w-xs rounded-[32px]'}
						src={'/images/img_23.webp'}
						w={380}
						h={380}
						alt={'Sexually transmitted infections (STIs)'}
					/>
				</Group>
				<Card
					className={'mx-auto w-full h-full mt-20 mb-20'}
					style={{
						backgroundImage: 'url(/images/img_24.webp)',
						minHeight: 278,
						backgroundSize: 'cover',
						backgroundRepeat: 'no-repeat',
						borderRadius: 30,
						maxWidth: '1148px',
					}}
				>
					<Flex className={'h-full w-full md:p-8 px-1 py-8 gap-4 justify-center items-center'} direction={'column'} align={'center'}>
						<Title ta={'center'} variant={'cyan'} fz={18}>
							What Is HIV?
						</Title>
						<Title className={'w-full'} variant={'title'} c={'white'}>
							Navigating Human
							<br />
							Immunodeficiency Virus (HIV)
						</Title>
						<Text className={'max-w-3xl'} ta={'center'} c={'white'}>
							Commonly confused with Acquired Immunodeficiency Syndrome (AIDS), HIV is a virus that targets the immune system, gradually damaging and
							destroying white blood cells. Untreated HIV can lead to AIDS, leaving individuals extremely vulnerable to other infections.
						</Text>
					</Flex>
				</Card>
			</TwContainer>
		</section>
	)
}
